import React from 'react'
import EbookData from '../ebook.json'
import ServerInfo from '../server.json'
import HorizontalList from '../common/HorizontalList'
import '../App.css';
import {
    Card,
    CardSection,
}from '../common'
import HeaderBar from '../common/HeaderBar'
import BottomBar from '../common/BottomBar'
import {connect } from 'react-redux'

class RequestReset extends React.Component {
    gotoLibrary = () =>
    {
        this.props.history.push('/library')
    }
    render() {
            return(                          
                <Card>
                    <HeaderBar history={this.props.history}></HeaderBar>
                    <div style={{padding: '80px', textAlign:'center'}}>
                        <h2>Your request is successful!</h2>
                        <p>An email has been sent to you.</p>
                        <p>Check your email and set your new password.</p>
                        <button style={this.buttonStyle} onClick={this.gotoLibrary}>Back</button>
                    </div>
                    <BottomBar history={this.props.history}></BottomBar>
                </Card>
            )
    }

    //Styles
    //Styles
    buttonStyle =
    {
        //flex: 1,
        backgroundColor: '#fff',
        borderRadius: 5,
        border: '1px solid #1e7b85',
        marginTop:12,        
        color: '#1e7b85',
        fontSize: 16,
        fontWeight: '600',
        padding: '10px 15px',
        width: '180px',
        cursor: 'pointer',
    }
}

export default connect(state => state)(RequestReset)